/**
 * @author xyguo
 * @description 新开业邮件通知
 * @Date 2021/3/11
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,component_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport,WizCard,WizTabs,WizSpin} = component_tool;
class RequirementNoticeList extends WizContainer {

  componentName = 'RequirementNoticeList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '省/自治区/直辖市',
        field: 'provincial',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '别称',
        field: 'anotherName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '是否为新能源店',
        field: 'isNewEnergyStr',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '新开业管理员',
        field: 'requirementManagerStr',
        width: 80,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'stateStr',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if(o['success']){
      let data = o['data']
      WizBrowserExport({
        title: '新开业邮件通知管理',
        sheetName: '新开业邮件通知管理',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '新开业邮件通知管理.xlsx'
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        enable: this._handleCMD,
        UpdateProgramStatus:this._handleCMD,
        export: this._handleFile,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(RequirementNoticeList);
